(function () {
  var PD = document.getElementById('ac-pdata'); var PRODUCT_TITLE = PD ? PD.getAttribute('data-title') : document.title;
  var C = {
    'nero':'#111111','bianco':'#ffffff','avorio':'#F6F1E3','crema':'#F3E9D2','beige':'#D9C3A0','beige chiaro':'#EBDDC5','beige grigio':'#C9BFAF',
    'sabbia':'#D8C3A5','kaki':'#B9A57E','cammello':'#C19A6B','marrone':'#6B4226','marrone chiaro':'#A47551','marrone scuro':'#4A2C1A',
    'cioccolato':'#4E2A1E','tortora':'#A39382','taupe':'#8B7D6B',
    'grigio':'#8E8E8E','grigio chiaro':'#C8C8C8','grigio scuro':'#555555','grigio cenere':'#B2B6AF','antracite':'#3A3A3A',
    'verde':'#3E8E41','verde oliva':'#556B2F','verde scuro':'#1E4D2B','verde militare':'#4B5320','verde salvia':'#A3B18A',
    'salvia':'#A3B18A','verde bottiglia':'#0B3D2E','verde smeraldo':'#1E7B5A','menta':'#A8D5BA',
    'blu':'#2457A6','blu navy':'#1F2A44','blu scuro':'#1B2A49','blu notte':'#191F3A','blu ardesia':'#5A6F8E','azzurro':'#87CEEB','celeste':'#A9D3EE',
    'denim':'#4A6A8C','turchese':'#30B5B0','petrolio':'#1D5C63',
    'rosso':'#C0392B','rosso veneziano':'#A4262C','rosso scuro':'#8B1E1E','rosso rosa':'#D9506A','bordeaux':'#6D1A2A',
    'vinaccia':'#5E1A2B','corallo':'#F08070','fucsia':'#D63384','rosa':'#F4A6B8','rosa chiaro':'#F8C8D4','rosa antico':'#C98B8B','cipria':'#E8C4BE',
    'viola':'#7B4B94','lilla':'#C8A2C8','lavanda':'#B9A7D6','prugna':'#5B2A4A',
    'giallo':'#F2C94C','giallo chiaro':'#F7E08A','senape':'#D4A72C','oro':'#C9A44C','arancione':'#E67E22','albicocca':'#F4B183','terracotta':'#C0623F',
    'argento':'#C0C0C0','nero e verde':'#2B3A2B'
  };
  var BASE = ['nero','bianco','avorio','crema','beige','kaki','cammello','marrone','grigio','verde','blu','azzurro','celeste',
              'rosso','bordeaux','rosa','viola','lilla','lavanda','giallo','arancione','oro','argento','salvia','sabbia','terracotta'];
  function colorFor(val) {
    var k = (val || '').trim().toLowerCase();
    if (C[k]) return C[k];
    var parts = k.split(/[\s\-\/]+/);
    for (var i = 0; i < BASE.length; i++) if (parts.indexOf(BASE[i]) !== -1) return C[BASE[i]];
    return null;
  }
  var CM_RE = /^\s*(\d+(?:[.,]\d+)?)(?:\s*[–-]\s*(\d+(?:[.,]\d+)?))?\s*(cm)?\s*$/i;
  function toInch(t) {
    var m = t.match(CM_RE); if (!m) return t;
    var f = function (x) { return (parseFloat(x.replace(',', '.')) / 2.54).toFixed(1); };
    return f(m[1]) + (m[2] ? '–' + f(m[2]) : '') + (m[3] ? ' in' : '');
  }

  /* ---------- Finestra della guida ---------- */
  var dlg = null;
  function buildDialog() {
    if (dlg) return dlg;
    var content = null, hasToggle = false;
    var meta = document.getElementById('ac-sg-meta');
    if (meta) {
      content = document.createElement('div');
      content.appendChild(meta.content.cloneNode(true));
      hasToggle = true;
    } else {
      var desc = document.querySelector('.product__description');
      if (!desc) return null;
      var moved = [];
      var heads = Array.prototype.filter.call(desc.querySelectorAll('h1,h2,h3,h4,h5,h6,p'), function (h) {
        return /guida alle taglie/i.test(h.textContent) && h.textContent.trim().length < 60 && !h.querySelector('img');
      });
      heads.forEach(function (h) {
        var rest = h.textContent.replace(/guida alle taglie/i, '').replace(/^[\s–—:\-]+|[\s–—:\-]+$/g, '');
        if (rest) { var part = document.createElement('p'); part.className = 'ac-sg__part'; part.textContent = rest; moved.push(part); }
        var el = h.nextElementSibling;
        while (el && (el.tagName === 'TABLE' || el.querySelector('table') || (el.tagName === 'P' && /misure|centimetri|variare/i.test(el.textContent) && el.textContent.length < 160))) {
          var next = el.nextElementSibling; moved.push(el); el = next;
        }
        h.parentNode.removeChild(h);
      });
      Array.prototype.forEach.call(desc.querySelectorAll('img'), function (img) {
        if (/guida alle taglie|size chart|tabella taglie/i.test(img.getAttribute('alt') || '')) {
          var box = img.closest('p') || img;
          if (moved.indexOf(box) === -1) {
            moved.push(box);
            var nx = box.nextElementSibling;
            if (nx && nx.tagName === 'P' && /misure|centimetri|variare/i.test(nx.textContent) && nx.textContent.length < 160) moved.push(nx);
          }
        }
      });
      if (!moved.length) return null;
      content = document.createElement('div');
      moved.forEach(function (n) { content.appendChild(n); });
      Array.prototype.forEach.call(content.querySelectorAll('td'), function (td) {
        if (CM_RE.test(td.textContent) && /cm/i.test(td.textContent)) { td.setAttribute('data-cm', td.textContent.trim()); hasToggle = true; }
      });
    }
    dlg = document.createElement('dialog');
    dlg.className = 'ac-sg';
    dlg.innerHTML =
      '<button type="button" class="ac-sg__close" aria-label="Chiudi">×</button>' +
      '<h3 class="ac-sg__title"></h3><p class="ac-sg__sub">Guida alle taglie</p>' +
      (hasToggle ? '<div class="ac-sg__toggle"><button type="button" class="is-on" data-unit="cm">cm</button><button type="button" data-unit="in">pollici</button></div>' : '') +
      '<div class="ac-sg__wrap"></div>' +
      '<p class="ac-sg__note">Indecisa tra due taglie? Scegli la più grande per un comfort e una vestibilità migliori.</p>' +
      '<p class="ac-sg__brand">ALBA CAPRI</p>';
    dlg.querySelector('.ac-sg__title').textContent = PRODUCT_TITLE;
    dlg.querySelector('.ac-sg__wrap').appendChild(content);
    document.body.appendChild(dlg);
    dlg.querySelector('.ac-sg__close').addEventListener('click', function () { dlg.close ? dlg.close() : dlg.removeAttribute('open'); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
    Array.prototype.forEach.call(dlg.querySelectorAll('.ac-sg__toggle button'), function (btn) {
      btn.addEventListener('click', function () {
        var inch = btn.getAttribute('data-unit') === 'in';
        Array.prototype.forEach.call(dlg.querySelectorAll('.ac-sg__toggle button'), function (b) { b.classList.toggle('is-on', b === btn); });
        Array.prototype.forEach.call(dlg.querySelectorAll('td[data-cm]'), function (td) { td.textContent = inch ? toInch(td.getAttribute('data-cm')) : td.getAttribute('data-cm'); });
        Array.prototype.forEach.call(dlg.querySelectorAll('.ac-u'), function (u) { u.textContent = inch ? '(in)' : '(cm)'; });
      });
    });
    return dlg;
  }

  /* ---------- Colori e taglie ---------- */
  var tpl = document.getElementById('ac-sg-link-tpl');
  function optionName(fs) {
    var inp = fs.querySelector('input[data-option-name]');
    var lg = fs.querySelector('legend');
    return ((inp && inp.getAttribute('data-option-name')) || (lg ? lg.textContent : '')).toLowerCase();
  }
  function apply() {
    var d = buildDialog();
    Array.prototype.forEach.call(document.querySelectorAll('variant-selects fieldset'), function (fs) {
      var n = optionName(fs);
      var lg = fs.querySelector('legend');
      if (lg && !lg.querySelector('.ac-lbl')) {
        var lbl = document.createElement('span'); lbl.className = 'ac-lbl';
        while (lg.firstChild) lbl.appendChild(lg.firstChild);
        lg.appendChild(lbl);
      }
      if (/colou?re?|couleur|farbe/.test(n)) {
        fs.classList.add('ac-colors');
        Array.prototype.forEach.call(fs.querySelectorAll('input[type="radio"]'), function (inp) {
          var lab = fs.querySelector('label[for="' + inp.id + '"]');
          var hex = colorFor(inp.value);
          if (!lab || !hex || lab.classList.contains('ac-sw')) return;
          lab.classList.add('ac-sw');
          lab.style.setProperty('--ac-c', hex);
          lab.setAttribute('title', inp.value);
        });
        if (lg) {
          var host = lg.querySelector('.ac-lbl');
          var s = host.querySelector('.ac-color-name');
          if (!s) { s = document.createElement('span'); s.className = 'ac-color-name'; host.appendChild(s); }
          var c = fs.querySelector('input:checked');
          var txt = c ? ' — ' + c.value : '';
          if (s.textContent !== txt) s.textContent = txt;
        }
      }
      if (d && tpl && lg && /taglia|size|talla/.test(n) && !lg.querySelector('.ac-sg-link')) {
        var link = tpl.content.firstElementChild.cloneNode(true);
        link.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); d.showModal ? d.showModal() : d.setAttribute('open', ''); });
        lg.appendChild(link);
      }
    });
  }

  var queued = false;
  function schedule() { if (queued) return; queued = true; requestAnimationFrame(function () { queued = false; apply(); }); }
  function start() {
    apply();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('change', function (e) { if (e.target.closest && e.target.closest('variant-selects')) schedule(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
